module.exports = __webpack_public_path__ + "752596beed9a608e9f215c43c4714e20.svg";